import React from 'react';
import Navbar from '../components/resuableComponents/Navbar/Navbar';
import Footer from '../components/resuableComponents/Footer';
import { Container, Divider, Grid } from '@mui/material';
import { useEffect } from 'react';

const step = [
	'-> API Integration can be ready-made or customized totally depends upon Travel Agency requirements and Budget. If Travel Agency has a small budget to start an online booking system on their brand name then they can go with a white label solution.',
	'-> High Profitability and Global reach helps to increase the revenue of your Travel Agency.',
	'-> It provides more flexibility to make changes in your portal. Additional features also to be given to the consumers according to their choices.',
	'-> Fast and Error free online booking facility helps to gain good feedback and reviews.',
	'-> Personalised service attracts the user as the portal becomes very user friendly.',
	'-> Live Tracking, Social Media Integration helps in marketing of your business.',
	'-> Customization and Editing Facility boost your business in every aspect.',
	'-> Online payment through Payment Gateways API Integration.',
	'-> Not waiting for confirmation.',
	'-> 24/7 technical support gives your business more flexibilities.',
	'-> Less running and maintenance cost compare to offline system.',
	'-> SMS and E-Mail API Integration for Booking related notifications.',
	'-> Global supplier API integration provide vast inventory to your users.',
	'-> Fully automation from supplier to user makes your business less complex.',
	'-> Instant Booking Confirmation makes your portal more reliable and flexible for users.',
	'-> Easy Management helps you in doing stress free business and run your business with joy.',
	'-> Integrated Payment Gateway makes portal more flexible by giving multiple payment modes.',
	'-> This also helps in your brand promotion. By providing the best inventory at a reasonable price to your customer you can build customer faith and high satisfaction.',
];

const step2 = [
	'Page Management',
	'Blog management',
	'Website Management',
	'SEO Friendly',
	'Visitor Tracking',
	'Live Chat Integration',
	'Own Branding',
	'Payment Gateway Integration',
	'Email Integration',
	'SMS Integration',
	'Social Media Integration',
	'Customer dashboard',
	'Centralised Mid office',
];
const step3 = [
	'Markup management',
	'Offer Management',
	'Discount Management',
	'Convenience Fee Management',
	'Coupon Management',
	'Staff Management',
	'Advance reports',
	'Unlimited Bandwidth',
	'SSL Secure website',
	'Customer Feedback',
	'E Ticket',
	'large service network',
	'24*7 technical support',
];
const IOS = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	return (
		<div>
			<Navbar />

			<div
				style={{
					backgroundImage:
						"url('https://aryaaviation.com/assets/images/travel-portal-ios-mobile-app.jpg')",
					height: '25vh',
					fontSize: '50px',
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
				}}>
				<h1 style={{ textAlign: 'center', color: 'white', padding: 10 }}>
					iOS MOBILE APP DEVELOPMENT
				</h1>
				<h6 style={{ textAlign: 'center', fontSize: 20, color: 'white' }}>
					iOS MOBILE APP DEVELOPMENT
				</h6>
			</div>

			<div style={{ padding: 10 }}>
				<h1 style={{ textAlign: 'center', fontSize: 30, marginTop: 20 }}>
					iOS MOBILE APP DEVELOPMENT
				</h1>
				<Divider />
				<Container style={{ marginTop: 20 }}>
					<Grid container spacing={4}>
						<Grid item xs={4}>
							<img src='https://aryaaviation.com/assets/images/ios-develop.png' />
						</Grid>
						<Grid item xs={8}>
							<p>
								iOS App development is the new marketing norm of the present
								world. Now just for your knowledge, 900 million iphones were
								sold in March 2016. Demand for iphone is increasing day by day
								across the world, iOS App Development particularly in the
								developing countries. Want to miss that 700 million and more
								potential customers in this big moment. It is definitely a big
								desperation for any company missing them. Create a
								result-oriented iOS app development plan and go ahead.
							</p>
							<br />
							<p>
								We offer best in class iOS app development that increases your
								revenues by appealing the customers through their iphones. iOS
								Apps done by us uses the best tools that present in the world
								today. By using a user-centric design, we neurotically compel
								the customer to use their intelligence in making purchase. An
								average person spends almost 3 hours on their iphone every day;
								this figure is even higher among the teenagers. It can take your
								business in the core of the iphone user’s daily life, and
								ultimately convert them into buyers.
							</p>
							<br />
							<p>
								The iOS App development teams in Arya Aviation are expert in
								their field, and they can handle any custom iOS app development
								with perfect ease and enthusiasm. All apps made are fully
								compatible with the latest versions with support for older
								versions, including full compatibility with 2G/3G/4G and Wi-Fi
								network coverage. We will provide you with regular updates of
								your iOS application along with dedicated support for any
								doubts, queries or changes you might want to make in your
								product. We will guide you through all of the steps that will
								convert your ideas into your iphone compatible app with our 8
								years of experience in custom iOS application development.?
							</p>
							<br />{' '}
							<p>
								Custom iOS app development is the next generation marketing
								tools used by global companies to reach new markets and
								customers, because iOS app development is flexible, easy and
								effective. Let us take an example, by looking at the growth of
								iphone and ipads, most of the international and national banks
								have introduced their custom IOS Apps, which has helped them to
								increase their customer base. The full potential of custom iOS
								app development is still largely unidentified
							</p>
							<br />
						</Grid>
					</Grid>
				</Container>

				<Divider />
			</div>

			<Footer />
		</div>
	);
};

export default IOS;
